import React from 'react';

const FloatingLabelInput = ({ as: Component = 'input', id, name, label, value, onChange, type = 'text', required = false, ...props }) => {
    return (
        <div className="relative">
            <Component
                id={id}
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                required={required}
                placeholder=" "
                className="block px-3 pb-2.5 pt-4 w-full text-md text-gray-900 dark:text-white bg-transparent rounded-lg border-2 border-gray-300 dark:border-gray-600 appearance-none focus:outline-none focus:ring-0 focus:border-primary-500 peer"
                {...props}
            />
            <label
                htmlFor={id}
                className="absolute text-md text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-800 px-2 peer-focus:px-2 peer-focus:text-primary-600 peer-focus:dark:text-primary-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            >
                {label}
            </label>
        </div>
    );
};

export default FloatingLabelInput; 